import React from 'react';

interface AuthLayoutProps {
  children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col sm:flex-row bg-gradient-to-br from-blue-50 to-purple-50">
      {/* Left Panel - Branding (hidden on mobile) */}
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-blue-600 to-indigo-800 p-8 text-white">
        <div className="flex flex-col justify-center max-w-md mx-auto">
          <div className="mb-8">
            <h1 className="text-4xl font-bold mb-2">Tradrfy</h1>
            <p className="text-blue-100 text-lg">
              Connecting homeowners with trusted local tradespeople
            </p>
          </div>
          
          <div className="space-y-6">
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
                <span className="text-sm">✓</span>
              </div>
              <div>
                <h3 className="font-semibold mb-1">Smart Matching</h3>
                <p className="text-blue-100 text-sm">
                  Our algorithm connects you with the most suitable professionals
                </p>
              </div>
            </div>
            
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
                <span className="text-sm">✓</span>
              </div>
              <div>
                <h3 className="font-semibold mb-1">Verified Tradespeople</h3>
                <p className="text-blue-100 text-sm">
                  All professionals are background checked and verified
                </p>
              </div>
            </div>
            
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
                <span className="text-sm">✓</span>
              </div>
              <div>
                <h3 className="font-semibold mb-1">Secure Payments</h3>
                <p className="text-blue-100 text-sm">
                  Protected payments and escrow services for peace of mind
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Panel - Auth Form */}
      <div className="flex-1 flex flex-col justify-center py-8 px-4 sm:px-6 lg:px-20 xl:px-24 sm:py-12">
        <div className="mx-auto w-full max-w-sm sm:max-w-md lg:w-96">
          {/* Show mobile header on small screens */}
          <div className="sm:hidden mb-8 text-center">
            <h1 className="text-3xl font-bold text-gray-900">Tradrfy</h1>
            <p className="mt-2 text-gray-600">
              Connecting homeowners with trusted local tradespeople
            </p>
          </div>
          
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;